import React from 'react';
import HeroMediaCarousel from './Carousel';
import CTAButton from './ui/CTAButton';
import useRevealOnScroll from '../hooks/useRevealOnScroll';

const HeroSection = () => {
  const { ref, isVisible } = useRevealOnScroll();

  return (
    <section className="relative overflow-hidden">
      <HeroMediaCarousel />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#162736d9] via-[#1e3a4cb3] to-[#1e3a4c4d]" />
      <div
        ref={ref}
        className={`section-shell absolute inset-0 z-10 flex items-center ${isVisible ? 'reveal-visible' : ''} reveal`}
      >
        <div className="max-w-2xl">
          <p className="mb-4 text-lg font-bold uppercase tracking-[0.2em] text-brand-accent">Holiday Motel, Orillia</p>
          <h1 className="font-heading text-4xl md:text-6xl text-white leading-tight">Comfortable stays with a refined, local touch.</h1>
          <p className="mt-5 max-w-xl text-base md:text-lg text-[#f1f4f5] leading-relaxed">
            Enjoy clean, practical rooms near downtown Orillia with friendly service, convenient parking, and dependable comfort.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-4 pointer-events-auto">
            <CTAButton href="tel:+17053251316" className="w-full sm:w-auto">
              Call Now
            </CTAButton>
            <CTAButton href="#rooms" className="w-full sm:w-auto bg-brand-accent text-[#1f2933] hover:bg-[#c99754]">
              View Rooms
            </CTAButton>
          </div>
        </div>
      </div>

      <div className="relative z-10 bg-brand-surface/95 border-y border-brand-border">
        <div className="section-shell py-6 md:py-8">
          <ul className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm md:text-base font-semibold text-brand-primary">
            <li className="card-surface px-5 py-4 text-center">Free Wi-Fi</li>
            <li className="card-surface px-5 py-4 text-center">Free Parking</li>
            <li className="card-surface px-5 py-4 text-center">3 Room Types</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
